import React, { useState } from 'react'

import i18n from 'i18next'

import { useTimeEntriesStore } from '@/stores/useTimeEntriesStore'

import AI_ICON from '@public/assets/ai.svg'

export default function AiTooltipWrapper() {
  const [isOpen, setIsOpen] = useState(true)
  const featureAiUsage = useTimeEntriesStore(state => state.featureAiUsage)

  if (!featureAiUsage || !isOpen) return null
  return (
    <div className="flex w-full min-w-0 items-center justify-between gap-3 border-t border-[#D9D9D9] bg-[#f5f5f5] px-3 py-1.5 text-sm font-normal text-[#333]">
      <div className="flex min-w-0 flex-1 items-center gap-[5px]">
        <img className="mt-0.5 shrink-0" src={AI_ICON} alt="" />
        <div className="min-w-0 break-words">
          <span>{String(i18n.t('tooltip.ai'))}</span>
          <a className="text-[#333]" href="mailto:support@matteroom.com">
            support@matteroom.com
          </a>
        </div>
      </div>

      <button
        type="button"
        className="flex h-3.5 w-3.5 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[#aeaeae]"
        aria-label="Close AI information"
        onClick={() => setIsOpen(false)}
      >
        <svg
          className="h-[11px] w-2.5"
          viewBox="0 0 10 11"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M9.949 1.699 6.148 5.5l3.801 3.801-1.148 1.148L5 6.648l-3.801 3.801L.051 9.301 3.852 5.5.05 1.699 1.2.551 5 4.352 8.8.55 9.95 1.7Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  )
}
